import { keyframes } from "@emotion/react";

import swingCurve from "./swing-curve.svg";
import swingSLogoWhite from "./swing-s-white.svg";
import swingSLogo from "./swing-s.svg";

/***** Constants *****/
const curveAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

/***** Types *****/
type LoadingInterstitialProps = {
  /**
   * Whether to invert the logo color.
   *
   * @default false
   */
  invertLogoColor?: boolean;
};

/**
 * Component | LoadingInterstitial
 *
 * A loading interstitial that displays a rotating curve and the Swing S logo.
 */
export function LoadingInterstitial(props: LoadingInterstitialProps) {
  const { invertLogoColor = false } = props;

  return (
    <div css={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <img src={invertLogoColor ? swingSLogoWhite : swingSLogo} css={{ position: "absolute" }} />
      <img src={swingCurve} css={{ animation: `${curveAnimation} 2s linear infinite` }} />
    </div>
  );
}
